/* import api from '../_api'; */
import moment from 'moment';
import { extractMaxValues } from '../../../assets/js/functions';
import { APIsummaryRequest } from '../../../assets/requests/request';
import { store } from '../../../store/store';

const updateSummaryCharts = ({ commit, rootState }) => {
  const { comparisonMode } = rootState;
  const { comparisonYears } = rootState;
  const { toDate } = rootState.requestParams;
  const { fromDate } = rootState.requestParams;
  const displayDateFormat = 'DD/MM/YYYY';
  const processDateFormat = 'YYYY-MM-DD';
  const { currentClient } = rootState.requestParams;
  const { industryAverage } = rootState.requestParams;

  const dataFilters = [];
  let baseFilter = {};
  let comparisonFilter = {};
  let dateFilter = { };

  if (comparisonMode === 'industry') {
    // Start with base filter
    const baseFilterContent = [];
    if (currentClient !== 'all') {
      baseFilterContent.push(
        {
          name: 'client_name',
          equation: '=',
          value: store.getters.getUsernameFromDisplayName(currentClient),
        },
      );
    }
    baseFilter = {
      filterName: 'Base',
      filterContent: baseFilterContent,
      internalOperator: 'OR',
    };

    // Comparison Filter
    comparisonFilter = {
      filterName: 'Comparison',
      filterContent: [{
        name: 'sector',
        equation: '=',
        value: industryAverage.toString(),
      }],
      internalOperator: '',
    };

    // And finally the date filter
    dateFilter = {
      filterName: 'Date',
      filterContent: [
        {
          name: 'log_time',
          equation: '>',
          value: fromDate,
        },
        {
          name: 'log_time',
          equation: '<',
          value: toDate,
        },
      ],
      internalOperator: 'AND',
    };

    dataFilters.push(baseFilter, comparisonFilter, dateFilter);

    // End of Industry Comparison
  }

  if (comparisonMode === 'date') {
    console.log('Date comp');
    // Start with Base
    let baseClientObject = false;
    if (currentClient !== 'all') {
      baseClientObject = {
        name: 'client_name',
        equation: '=',
        value: store.getters.getUsernameFromDisplayName(currentClient),
      };
    }

    baseFilter = {
      filterName: 'Base',
      filterContent: [
        {
          name: 'log_time',
          equation: '>',
          value: fromDate,
        },
        {
          name: 'log_time',
          equation: '<',
          value: toDate,
        },
      ],
      internalOperator: 'AND',
    };

    if (baseClientObject) { baseFilter.filterContent.push(baseClientObject); }

    dataFilters.push(baseFilter);

    for (let i = 1; i <= comparisonYears; i += 1) {
      const yearOnYearFilter = {
        filterName: `prevYear${i}`,
        filterContent: [
          {
            name: 'log_time',
            equation: '>',
            value: moment(fromDate).subtract(i, 'years').format(processDateFormat),
          },
          {
            name: 'log_time',
            equation: '<',
            value: moment(toDate).subtract(i, 'years').format(processDateFormat),
          },
        ],
        internalOperator: 'AND',
      };
      if (baseClientObject) {
        yearOnYearFilter.filterContent.push(baseClientObject);
      }
      dataFilters.push(yearOnYearFilter);
    }
  }

  const summaryRequest = {
    searchIn: 'api-uk3',
    filters: {
      filterSetName: '',
      dataFilters,
    },
  };

  function processResponse(response) {
    let legendItems = [];
    if (comparisonMode === 'industry') {
      legendItems = [
        store.getters.getDisplayNameFromUsername(
          rootState.displayData.currentClient,
        ),
        rootState.clientByIndustryLists.find(
          (obj) => obj.sectorIndex === industryAverage,
        ).industryName,
      ];
    } else if (comparisonMode === 'date') {
      const clientLabel = `${rootState.displayData.currentClient} ${moment(fromDate).format(displayDateFormat)} - ${moment(toDate).format(displayDateFormat)}`;
      legendItems.push(clientLabel);
      for (let i = 1; i <= comparisonYears; i += 1) {
        const yearLabel = `${moment(fromDate).subtract(i, 'years').format(displayDateFormat)} - ${moment(toDate).subtract(i, 'years').format(displayDateFormat)}`;
        legendItems.push(yearLabel);
      }
    }
    commit('updateLegendData', legendItems, { root: true });

    const chartData = {};
    const totalAppsData = {};

    response.summary_data.forEach((summaryData, index, object) => {
      const name = summaryData.filter_name;

      if (typeof name !== 'undefined') {
        totalAppsData[name] = summaryData.total;
        chartData[name] = {};

        chartData[name].onePlusFlagData = summaryData.data.find((category) => category.summary_category_name === '1+ flagged applications').summary_content;
        chartData[name].flagCategoriesData = summaryData.data.find((category) => category.summary_category_name === 'Flag categories').summary_content;
        chartData[name].disadvantageBreakdownData = summaryData.data.find((category) => category.summary_category_name === 'Disadvantage breakdown').summary_content;
        chartData[name].flagBreakdownData = summaryData.data.find((category) => category.summary_category_name === 'Flag breakdown').summary_content;
        chartData[name].topOutperformersData = summaryData.data.find((category) => category.summary_category_name === 'Top 10% outperformers').summary_content;
        chartData[name].countryBreakdownData = summaryData.data.find((category) => category.summary_category_name === 'Country breakdown').summary_content;
      } else {
        object.splice(index, 1);
      }
    });

    commit('updateSummaryChartData', chartData);
    commit('updateTotalApplications', totalAppsData, { root: true });
    commit('updateSummaryMaxValues', extractMaxValues(response.summary_data));
  }

  return new Promise((resolve, reject) => {
    const hash = rootState.requestParams.currentParamsHash;
    if (hash in rootState.responseCache.summary) {
      processResponse(rootState.responseCache.summary[hash]);
      resolve(true);
    } else {
      const requestParams = {
        headers: { 'x-dashboard-token': store.getters['$_login/accessToken'] },
        auth: {
          username: store.getters['$_login/userName'],
          password: '',
        },
      };
      APIsummaryRequest.post('', summaryRequest, requestParams).then((response) => {
        if (response.status !== 200) {
          throw new Error('Request not successful');
        }
        processResponse(response.data);
        commit('addAPIresponseToCache', { response: response.data, module: 'summary' }, { root: true });
        resolve(response);
      }, (error) => {
        reject(error);
      });
    }
  });
};

export default {
  updateSummaryCharts,
};
